import { Component, Vue } from 'vue-property-decorator'

@Component
export default class ScriptLoader extends Vue {
  public static preloadScript(src: string): Promise<void> {
    // eslint-disable-line no-param-reassign
    return new Promise((resolve: () => void, reject: () => void) => {
      if (!src || src === '') {
        resolve()
      }

      if (document.querySelector('script[src="' + src + '"]')) {
        resolve()
        return
      }

      const script = document.createElement('script')

      script.type = 'text/javascript'
      script.async = false
      script.src = src

      script.onload = () => resolve()
      script.onerror = () => reject()
      script.onabort = () => reject()

      document.head.appendChild(script)
    })
  }

  public static unloadScript(src: string): Promise<void> {
    return new Promise((resolve, _reject) => {
      if (!src || src === '') {
        resolve()
      }

      const script = document.querySelector('script[src="' + src + '"]')
      if (!script) {
        // nothing to unload
        resolve()
        return
      }

      if (process.env.VUE_APP_MULTI_PAGE_APP_BEHAVIOUR === 'true') {
        document.head.removeChild(script)
      }

      resolve()
    })
  }
}
